"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _DocFlux2 = _interopRequireDefault(require("./DocFlux"));

var _TestWrapper = _interopRequireDefault(require("./TestWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// Used to filter out invalid rendered items.
var isValidSubValue = function isValidSubValue(value) {
  return value !== undefined && value !== null;
};
/**
 * Used to test Document components using the shallow command.  This will only
 * render the imediate component.
 * @module DocFluxTest
 */


var DocFluxTest = /*#__PURE__*/function (_DocFlux) {
  _inherits(DocFluxTest, _DocFlux);

  var _super = _createSuper(DocFluxTest);

  function DocFluxTest() {
    _classCallCheck(this, DocFluxTest);

    return _super.apply(this, arguments);
  }

  _createClass(DocFluxTest, null, [{
    key: "mount",
    value: function mount(component, parser) {
      return _DocFlux2["default"].render(component, parser);
    }
  }, {
    key: "renderComponentArray",
    value: function renderComponentArray(components, renderFunc) {
      var cleanedRender = components.filter(isValidSubValue);
      var renderSubComponents = cleanedRender.map(function (comp) {
        return renderFunc(comp);
      }).filter(isValidSubValue);
      return renderSubComponents;
    }
  }, {
    key: "renderComponent",
    value: function renderComponent(component, renderFunc) {
      var ComponentClass = component.node;

      var props = _DocFlux2["default"].parseProps(component.props, ComponentClass.defaultProps);

      _DocFlux2["default"].validateProps(props, ComponentClass.propTypes, ComponentClass.name);

      var value;

      if (ComponentClass.prototype && ComponentClass.prototype.render) {
        var initializedComponent = new ComponentClass(props);
        value = renderFunc(initializedComponent.render());

        if (ComponentClass.transform) {
          return {
            ref: initializedComponent,
            value: value,
            elementName: component.stringNodeName,
            props: props
          };
        }
      } else {
        value = renderFunc(ComponentClass(props));
      }

      return value;
    }
    /**
     * Shallow renders only the imediate component tree
     * @static
     * @function
     * @param {Component} JSXComponent A component to shallow render
     * @return {Wrapper} A test wrapper representing the tree
     */

  }, {
    key: "shallow",
    value: function shallow(component) {
      var nest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var parent = _DocFlux2["default"];
      var self = DocFluxTest;

      var shallowFunc = function shallowFunc(c) {
        return self.shallow(c, nest);
      };

      var shallowEndNestFunc = function shallowEndNestFunc(c) {
        return self.shallow(c, false);
      };

      if (component === undefined || component === null) return new _TestWrapper["default"]();

      if (parent.isDOMNode(component)) {
        var tree = shallowFunc(component.props.children);
        return new _TestWrapper["default"](component, tree);
      } // Clean arrays and render items.


      if (parent.isArray(component)) {
        var _tree = self.renderComponentArray(component, shallowFunc);

        return _tree;
      } // Render components


      if (parent.isComponent(component)) {
        if (component.stringNodeName) {
          var _tree2 = self.renderComponent(component, shallowFunc);

          if (_tree2.ref) {
            _tree2 = new _TestWrapper["default"](_tree2);
          }

          return new _TestWrapper["default"](component, _tree2);
        }

        if (nest) {
          var _tree3 = self.renderComponent(component, shallowEndNestFunc);

          return new _TestWrapper["default"](component, _tree3);
        }

        return new _TestWrapper["default"](component);
      }

      if (component.node !== undefined) {
        throw new Error("Undefined Node: ".concat(component.stringNodeName));
      }

      return component;
    }
  }]);

  return DocFluxTest;
}(_DocFlux2["default"]);

exports["default"] = DocFluxTest;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@harvest-profit/doc-flux/dist/DocFluxTest.js
// module id = 46
// module chunks = 0